<template>
  <app-regions-select :label="$t('DELIVERY_REGIONS_SELECT.TITLE')"
                      :regions="deliveryRegions"
                      :value="value"
                      @input="emit">
  </app-regions-select>
</template>

<script>
import facetsService from '@/services/facetsService'
import AppRegionsSelect from '../regions-select/RegionsSelect'

export default {
  name: 'AppDeliveryRegionsSelect',
  components: { AppRegionsSelect },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isLoading: false,
      deliveryRegions: []
    }
  },
  created () {
    this.getDeliveryRegions()
  },
  methods: {
    async getDeliveryRegions () {
      this.isLoading = true

      try {
        this.deliveryRegions = await facetsService.findAllDeliveryRegions()
      } catch (error) {
        console.error(error)
      }

      this.isLoading = false
    },
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>
